import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import { ThemeProvider } from "components/ui/Header";
import { AuthProvider } from "./contexts/AuthContext";
import { ConvexProvider } from "convex/react";
import { convexClient } from "./lib/convexClient";

import NotFound from "pages/NotFound";
import AetherFeed from './pages/aether';
import SearchResults from './pages/search-results';
import LoginPage from './pages/login';
import UserProfile from './pages/user-profile';
import Register from './pages/register';
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/Dashboard';
import UserManagement from './pages/admin/UserManagement';
import ContentModeration from './pages/admin/ContentModeration';
import SystemMonitor from './pages/admin/SystemMonitor';
import Analytics from './pages/admin/Analytics';
import AdminSettings from './pages/admin/Settings';
import CurationPage from './pages/curation';
import SalonPage from './pages/salon';
import ReelsPage from './pages/reels';
import GamingNews from './pages/gaming-news';
import ArchitecturePage from './pages/architecture';
import ContractsMarketplace from './pages/contracts';
import MobileLayout from './components/mobile/MobileLayout';

const Routes = () => {
  return (
    <ConvexProvider client={convexClient}>
      <BrowserRouter>
        <ErrorBoundary>
          <AuthProvider>
            <ThemeProvider>
            <ScrollToTop />
            <MobileLayout>
            <RouterRoutes>
              {/* Define your route here */}
              <Route path="/" element={<AetherFeed />} />
              <Route path="/news-feed" element={<AetherFeed />} />
              <Route path="/search-results" element={<SearchResults />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/user-profile" element={<UserProfile />} />
              <Route path="/register" element={<Register />} />
              <Route path="/curation" element={<CurationPage />} />
              <Route path="/salon" element={<SalonPage />} />
              <Route path="/reels" element={<ReelsPage />} />
              <Route path="/gaming" element={<GamingNews />} />
              <Route path="/architecture" element={<ArchitecturePage />} />
              <Route path="/contracts" element={<ContractsMarketplace />} />
              
              {/* Admin Routes */}
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="users" element={<UserManagement />} />
                <Route path="content" element={<ContentModeration />} />
                <Route path="reports" element={<ContentModeration />} />
                <Route path="analytics" element={<Analytics />} />
                <Route path="monitor" element={<SystemMonitor />} />
                <Route path="settings" element={<AdminSettings />} />
              </Route>

              <Route path="*" element={<NotFound />} />
            </RouterRoutes>
            </MobileLayout>
            </ThemeProvider>
          </AuthProvider>
        </ErrorBoundary>
      </BrowserRouter>
    </ConvexProvider>
  );
};

export default Routes;
